// extracted by mini-css-extract-plugin
var _1 = "TileElement_icon__c5c81";
var _2 = "TileElement_root__7ed11";
export { _1 as "icon", _2 as "root" }
